export default class SolicitanteEnderecoModel {
  constructor({
    id = 0,
    nome = null,
    cep = '',
    estado = '',
    cidade = '',
    bairro = '',
    rua = '',
    numero = '',
    complemento = null,
    pontoDeReferecia = null,
  } = {}) {
    this.id = id
    this.nome = nome
    this.cep = cep
    this.estado = estado
    this.cidade = cidade
    this.bairro = bairro
    this.rua = rua
    this.numero = numero
    this.complemento = complemento
    this.pontoDeReferecia = pontoDeReferecia
  }
}
